<template>
    <layout
        :showuserinfo="false"
        :title="`Cukai Tanah: ${cukai.no_hm ?? 'Loading...'} `"
        :crumbs="crumbs"
    >
        <w-flex class="align-center justify-center" v-if="loading">
            <w-spinner />
        </w-flex>

        <z-page
            class=""
            title="Kemaskini Pengecualian"
            :append-button="true"
            v-if="!loading"
        >
            <w-flex :gap="3" column>
                <w-card bg-color="" class="table-hardcode">
                    <hakmilik :cukai="cukai" />
                </w-card>

                <w-card>
                    <w-form @submit.prevent="kemaskini">
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 25%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >No. MKNK</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>

                                <w-input
                                    v-model="form.no_mknk"
                                    style="color: blue"
                                    disabled
                                ></w-input>
                            </div>
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 25%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Nama Pemilik</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>

                                <w-input
                                    v-model="namaPemilik"
                                    style="color: blue"
                                    disabled
                                ></w-input>
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 16.3%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Tarikh Mula</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>

                                <w-input
                                    v-model="tarikh_mula"
                                    style="color: blue"
                                    disabled
                                />
                            </div>
                            <div class="xs6">
                                <w-select
                                    label="Status"
                                    v-model="form.status"
                                    :items="status"
                                    :placeholder="[[stat]]"
                                    outline
                                    tile
                                />
                            </div>
                        </w-flex>

                        <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit"
                                >Kemaskini
                            </w-button>
                        </div>
                    </w-form>
                </w-card>
            </w-flex>
        </z-page>
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import { Inertia } from "@inertiajs/inertia";
import moment from "moment";

export default {
    extends: ZResource,
    props: {
        pengecualian: [Object],
    },
    components: {
        Hakmilik,
    },
    data() {
        var moment = require("moment");
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                {
                    label: "Pengecualian",
                    route: "/cukai-tanah/showPengecualian",
                },
                { label: "Kemaskini Pengecualian" },
            ],
            cukai: [],
            cukais: [],
            form: {
                hm_akaun_id:null,
                no_mknk: this.pengecualian.no_mknk,
                id: null,
            },
            status: [
                { value: 1, label: "Aktif" },
                { value: 0, label: "Tidak Aktif" },
            ],
            loading: true,
            stat: null,
            tarikh_mula: null,
            namaPemilik: null,
        };
    },
    methods: {
        async kemaskini() {
            await axios({
                method: "put",
                url: `${this.apiBaseUrl}/cukai/pengecualian/${this.form.id}`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        console.log(e.data);
                    }
                })
                .finally((e) => {
                    window.location.href = `/cukai-tanah/pengecualian/${this.cukai.no_hm}`;
                });
            // Inertia.post("/cukai-tanah/kemaskini-ampun-hasil",l);
        },
        async searchCukai(no_hm) {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                barcode: no_hm,
                kodDaerah: "01",
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        this.cukai = e.data[0];
                        this.form.hm_akaun_id = e.data[0].id;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async getData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/pengecualian?no_mknk=${this.pengecualian.no_mknk}&limit=1&offset=0`,
                responseType: "json",
            }).then((e) => {
                this.cukais = e.data.data[0];
                this.searchCukai(e.data.data[0].no_hm);
                this.tarikh_mula = moment(e.data.data[0].tarikh_mula).format(
                    "DD-MM-YYYY"
                );
                this.form.id = e.data.data[0].id;
                // this.namaPemilik = e.data[0].pemiliks[0].nama;
                (this.namaPemilik = e.data.data[0].pemiliks.map((d) => {
                    return d.nama;
                })),
                    // console.log(this.namaPemiliks);
                    (this.stat = e.data.data[0].status);
                this.tarikh_tamat = moment(e.data.data[0].tarikh_tamat).format(
                    "DD-MM-YYYY"
                );
            });
        },
    },
    watch: {},
    mounted() {
        this.getData();
        this.dialog.width = 500;
    },
};
</script>
<style>
::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(35, 71, 129);
    font-style: normal;
    opacity: 1; /* Firefox */
}
</style>
